import React from "react";

import Modal from "../Modal";
import Button from "../Button";
import { WHATSAPP_UPGRADE_URL } from "../../helpers/constants";

const modalContentByFeature = {
    theme: {
        icon: '🎨',
        headline: 'Desbloqueie mais temas',
        subhead: 'Personalize o visual do seu site com designs exclusivos',
        benefits: [
            'Acesso a diversos layouts profissionais',
            'Temas desenvolvidos para o mercado de brindes personalizados',
            'Escolha o visual ideal para destacar sua marca',
        ]
    },
    calculation: {
        icon: '🚀',
        headline: 'Desbloqueie o cálculo de preço',
        subhead: 'Preço e estoque direto do fornecedor',
        benefits: [
            'Preço por quantidade',
            'Custos e margens no orçamento',
            'Variáveis de cálculo personalizadas',
            'Custo de gravação por técnica',
            'Orçamentos mais profissionais e precisos'
        ]
    },
    stock: {
        icon: '📦',
        headline: 'Desbloqueie o controle de estoque',
        subhead: 'Acompanhe o estoque dos seus produtos em tempo real',
        benefits: [
            'Estoque atualizado automaticamente',
            'Estoque direto do fornecedor',
            'Estoque por variação'
        ]
    },
    similar_search: {
        icon: '🔍',
        headline: 'Desbloqueie a busca por semelhança',
        subhead: 'Encontre produtos similares em segundos',
        benefits: [
            'Busque produtos iguais ou parecidos',
            'Compare preços e estoques em vários fornecedores',
            'Encontre produtos parecidos no mesmo fornecedor'
        ]
    },
    external_api: {
        icon: '🔗',
        headline: 'Desbloqueie a API externa',
        subhead: 'Integre seu ERP ou CRM diretamente à Brinde.me',
        benefits: [
            'Conecte a Brinde.me aos sistemas que sua empresa já utiliza',
            'Automatize a criação de orçamentos e a consulta de pedidos',
            'Tenha acesso programático ao catálogo de produtos e preços',
            'Reduza tarefas manuais e ganhe mais produtividade',
        ]
    },
    webhook: {
        icon: '⚡',
        headline: 'Desbloqueie os Webhooks',
        subhead: 'Receba notificações em tempo real no seu sistema',
        benefits: [
            'Seu sistema é avisado imediatamente quando algo acontece na Brinde.me',
            'Integre pedidos, orçamentos e propostas sem atrasos',
            'Acione fluxos automáticos no ERP, CRM ou outras ferramentas',
            'Reduza integrações complexas e elimine a necessidade de polling',
            'Configuração simples, entrega segura e documentação completa',
        ]
    },
    catalog_feed: {
        icon: '🛒',
        headline: 'Desbloqueie os feeds de catálogo',
        subhead: 'Anuncie seus produtos no Google, na Meta e na Free Shop',
        benefits: [
            'Feed XML sempre atualizado com seus produtos e preços',
            'Compatível com Google Merchant, Meta (Facebook/Instagram) e Free Shop',
            'Escolha quais categorias enviar para cada canal',
            'Mais visibilidade e vendas nos canais de anúncio',
        ]
    },
    brands: {
        icon: '🏷️',
        headline: 'Desbloqueie as Marcas',
        subhead: 'Um site próprio para cada marca que você atende',
        benefits: [
            'Domínio, logo e cores próprios de cada marca',
            'Catálogo exclusivo, com produtos que não aparecem no site principal',
            'Site aberto ao público ou restrito a pessoas cadastradas',
            'Banners, páginas e SEO configurados por marca',
        ]
    },
    product_mock: {
        icon: '✨',
        headline: 'Desbloqueie a amostra virtual',
        subhead: 'Mostre o brinde com a marca do cliente antes de produzir',
        benefits: [
            'Aplique o logo do cliente na foto do produto em segundos',
            'Marque a área de gravação e escolha a técnica: silk, laser, bordado, UV e mais',
            'Envie a proposta com a peça personalizada e feche mais rápido',
        ]
    },
    price_display: {
        icon: '💲',
        headline: 'Desbloqueie a exibição de preço no site',
        subhead: 'Mostre o preço dos produtos direto na sua vitrine',
        benefits: [
            'Preço por quantidade na página do produto',
            'Escolha quem vê: todos, quem tem cadastro ou só clientes aprovados',
            'O cliente chega no orçamento já sabendo quanto vai pagar',
        ]
    },
    price_filter: {
        icon: '🔎',
        headline: 'Desbloqueie o filtro de preço',
        subhead: 'Deixe o cliente encontrar o brinde dentro do orçamento dele',
        benefits: [
            'Faixa de preço por unidade na listagem e na busca do site',
            'Menos tempo procurando, mais pedidos de orçamento',
        ]
    },
    crm: {
        icon: '⚡',
        headline: 'Desbloqueie os Painéis (CRM)',
        subhead: 'Organize seus atendimentos, orçamentos e pedidos em um só lugar',
        benefits: [
            'Acompanhe cada negociação por etapas em painéis visuais',
            'Crie cards automaticamente a partir de orçamentos e pedidos',
            'Painéis por área: Comercial, Produção e Financeiro',
            'Notificações e menções da equipe em tempo real',
        ]
    },
    gestao: {
        icon: '💰',
        headline: 'Desbloqueie a Gestão financeira e fiscal',
        subhead: 'O dinheiro e as notas da operação no mesmo lugar dos pedidos',
        benefits: [
            'Contas a pagar e a receber geradas a partir do pedido, com extrato e conciliação bancária',
            'NF-e do produto e NFS-e da gravação emitidas do pedido, com aviso do que falta corrigir',
            'Pedidos de compra ligados à venda e notas de entrada dos fornecedores',
            'DRE e fluxo de caixa prontos para fechar o mês sem planilha',
        ]
    },
    open_finance: {
        icon: '🏦',
        headline: 'Desbloqueie o Open Finance',
        subhead: 'O extrato da sua conta chega sozinho, direto do banco',
        benefits: [
            'Autorize uma vez, no próprio banco, e revogue quando quiser',
            'Lançamentos novos duas vezes por dia, sem baixar arquivo OFX',
            'Sugestão do título pelo CPF/CNPJ de quem pagou ou recebeu',
            'Funciona com Itaú, Bradesco, Banco do Brasil, Santander, Inter, Sicoob e mais',
        ]
    },
};

export const PlanFeatureUpgradeModal = ({ feature, show, close }) => {
    const content = modalContentByFeature[feature];

    if (!content) {
        return null;
    }

    return (
        <Modal
            className="modal-upgrade"
            title="Recurso não disponível no seu plano"
            show={show}
            close={close}
            footer={
                <>
                    <Button type="primary" text="Falar no WhatsApp" action={() => window.open(WHATSAPP_UPGRADE_URL, '_blank')} />
                    <Button type="secondary" text="Fechar" action={close} />
                </>
            }
        >
            <div className="modal-upgrade__hero">
                <span className="modal-upgrade__icon">{content.icon}</span>
                <h2 className="modal-upgrade__headline">{content.headline}</h2>
                <p className="modal-upgrade__subhead">{content.subhead}</p>
            </div>
            <ul className="modal-upgrade__benefits">
                {content.benefits.map(benefit => (
                    <li key={benefit}>{benefit}</li>
                ))}
            </ul>
            <p className="modal-upgrade__cta-text">Entre em contato pelo WhatsApp e saiba mais.</p>
        </Modal>
    );
};

export default PlanFeatureUpgradeModal;
